module.exports = __webpack_public_path__ + "static/media/13.a1f59310.jpg";